import api from "./api";

class GruppiContattiManager {

    gruppiContatti(config?: any) {
        return api.get(`/gruppi_contatti`, config)
    }

    gruppoContatti(id: number | string) {
        return api.get(`/gruppi_contatti/${id}/`)
    }

    retrieve = this.gruppoContatti
    list = this.gruppiContatti
}

const gruppiContattiManager = new GruppiContattiManager()

export default gruppiContattiManager
